import { styled, Table } from '@mui/material'

const DenseTable = styled(Table, {
  name: 'DenseTable',
})(({ theme }) => ({
  '& .MuiTableCell-root': {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  // Reduce horizontal padding exept for the first and last cells
  '& .MuiTableCell-root:not(:first-of-type)': {
    paddingLeft: theme.spacing(0.5),
  },
  '& .MuiTableCell-root:not(:last-of-type)': {
    paddingRight: theme.spacing(0.5),
  },
}))

export default DenseTable
